import React from "react";

const FVFRFaq = ({ title, faqs }) => {
  return (
    <section className="fvfr-faq-section">
      <div className="container">
        <h2
          className="text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <div
          className="fvfr-faq-list"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          {faqs.map((faq, i) => (
            <div key={i} className="fvfr-faq-item">
              <p className="fvfr-faq-q">{faq.q}</p>
              <p className="fvfr-faq-a">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FVFRFaq;
